import { useLocation } from 'react-router'
import { DEFAULT_LANGUAGE } from '../constants'

const useQueryParamLang = () => {

    const urlQuery = new URLSearchParams(useLocation().search)
    const lang = urlQuery.get('lang') || DEFAULT_LANGUAGE

    return { lang }
}

export default useQueryParamLang
